import React from "react";
import { useParams, Link } from "react-router";
import { Button, Card } from "react-bootstrap";
import { ChangeLogTable, EntityAuditTrail } from "../../components/workbench";

interface AuditTrailProps {
  entityType: "deals" | "coupons" | "offers" | "brands";
}

export const KindredAuditTrail: React.FC<AuditTrailProps> = ({
  entityType,
}) => {
  const { id } = useParams<{ id: string }>();

  const backPath = `/kindred/${entityType}/${id}`;
  const entityLabel =
    entityType === "deals"
      ? "Deal"
      : entityType === "coupons"
        ? "Coupon"
        : entityType === "offers"
          ? "Offer"
          : "Brand";

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>
          Audit Trail — {entityLabel} {id}
        </h4>
        <div>
          <Link to={backPath}>
            <Button size="sm" variant="outline-secondary">
              ← Back to {entityLabel}
            </Button>
          </Link>
        </div>
      </div>

      <Card className="mb-3">
        <Card.Header className="py-2 small fw-semibold">
          Change log
          <span className="text-muted fw-normal ms-2">
            Our own record of changes made from this app, with before/after values.
          </span>
        </Card.Header>
        <Card.Body className="p-2">
          <ChangeLogTable
            filter={entityType === "brands" ? { brandId: id } : { entityId: id }}
          />
        </Card.Body>
      </Card>

      <h6 className="text-muted">Kindred audit trail</h6>
      <EntityAuditTrail entityType={entityType} entityId={id ?? ""} />
    </div>
  );
};
